/* eslint-disable react/prop-types */
import React from 'react';

import { InfoItem } from '@molecules';
import { usePage, useMedia } from '@api/hooks';
import { getImage } from '@utils/media';

const ListItem = ({ item }) => {
  const { page, ...pageQuery } = usePage({ id: item.pageId });
  const { media, ...mediaQuery } = useMedia(getImage(item));

  const description = (pageQuery.isFetching && 'Loading ...') || pageQuery.error?.message || item.url || page.title;
  const imageName = (mediaQuery.isFetching && 'Loading ...') || mediaQuery.error?.message || media.title;

  return (
    <InfoItem image={media.src} description={description}>
      {imageName}
    </InfoItem>
  );
};

export default ListItem;
